export default "__VITE_ASSET__CvBN1a2M__"